import rehabApi from '@Apis/rehab.api';
import { GroupSetsResponse, GetGroupSetResponse } from '@Types';

export const getGroupSets = () => {
  return rehabApi.get<GroupSetsResponse>(
    '/rehabTrees?listAllAndTrees=true&treeType=AGSet'
  );
};

export const getGroupSet = (groupSetId: string) => {
  return rehabApi.get<GetGroupSetResponse>(`/rehabTree/${groupSetId}`);
};
